import React, { useEffect, useState } from "react";
import {
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  AppBar,
  Toolbar,
  Box,
  useMediaQuery,
  Button,
} from "@mui/material";
import "../../styles/userPanel.scss";
// import SearchIcon from "@mui/icons-material/Search";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import EditIcon from "@mui/icons-material/Edit";
// import CloseIcon from "@mui/icons-material/Close";
import { axiosInstance } from "../../utils/tokenSetCookie";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const CUSTOM_UPLOAD_BASE_URL = import.meta.env.VITE_CUSTOM_UPLOAD_BASE_URL;
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;

import { useTranslation } from "react-i18next";
import { SearchResult, UserDetails } from "../../types/types";
import SearchDropdown from "../shareAnimation/searchAnimation";
import { useBrand } from "../../hooks/brandProvider";
import { Link } from "react-router-dom";

// Images
const defaultProfile = VISUALIZE__URL + "clinical-visuals-logo-icon.svg";
const LigerLogo = VISUALIZE__URL + "liger-medical-Banner-logo.svg";

interface HeaderProps {
  toggleSidebar: () => void;
  sidebarOpen: boolean;
}

const Header: React.FC<HeaderProps> = ({
  toggleSidebar,
  // sidebarOpen
}) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:820px)");
  const logos = useBrand();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [userDetails, setUserDetails] = useState<UserDetails | null>(null);
  const { t } = useTranslation();
  const [_isSearchList, setSearchList] = useState<SearchResult[]>([]);
  const users_name =
    userDetails && userDetails?.lastName
      ? `${userDetails?.firstName} ${userDetails?.lastName}`
      : userDetails?.firstName;
  // const [openSearch, setOpenSearch] = useState(false);

  const isLigerDomain = window.location.host.includes(
    import.meta.env.VITE_LIGER_HOST_NAME
  );
  useEffect(() => {
    // Function to fetch data
    const getUsernDetail = async () => {
      try {
        const response = await axiosInstance.get(
          API_BASE_URL + "users/getuserdetails"
        );

        if (response.status >= 200 && response.status <= 300) {
          setUserDetails(response.data.data);
          localStorage.setItem(
            "businessStatus",
            response.data.data.businessEntityStatus
          );
          localStorage.setItem("sessionId", response.data.data.sessionId);
          localStorage.setItem(
            "viewAccess",
            response.data.data.isFreeAccessUser
          );
          localStorage.setItem(
            "fullscreenStatus",
            response.data.data.animationFullScreenStatus.toString()
          );
          localStorage.setItem(
            "expiresOn",
            response.data.data.freeAccessExpiryDate
          );
          localStorage.setItem(
            "animationDuration",
            response.data.data.animationDuration
          );
          localStorage.setItem(
            "businessEntityStatus",
            response.data.data.businessEntityStatus 
          )
          // localStorage.setItem("firstTimeUser", response.data.data.firstTimeUser)
        }
      } catch (err) {
        console.log(err);
      }
    };
    getUsernDetail();
  }, []); // Empty dependency array ensures it runs only once on page load

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("activeMenu"); // Clear session storage for sidemenu highlighten
    localStorage.setItem("logoutEvent", Date.now().toString()); // Trigger event
    navigate("/logout"); // Navigate to the Logout page
    handleClose();
  };

  const handleProfile = () => {
    // Add your profile logic here
    navigate("/profile-setting"); // Navigate to the Profile page
    handleClose();
  };

  // const handleOpenSearch = () => setOpenSearch(true);
  // const handleCloseSearch = () => setOpenSearch(false);

  return (
    <AppBar
      position="fixed"
      sx={{
        padding: isMobile ? "0px" : "5px",
        backgroundColor: "#FFFFFF",
        boxShadow:
          "0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
        minHeight: "48px !important",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          minHeight: isMobile ? "64px" : "74px",
          padding: isMobile ? "0px 8px" : "0px 16px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {isMobile && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleSidebar}
              sx={{ mr: 0.5, color: "#1976d2" }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Link to="/home">
            <Box
              sx={{
                mr: 2,
                display: { xs: "", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
                width:
                  isMobile && isLigerDomain
                    ? 60
                    : isMobile
                      ? 150
                      : isLigerDomain
                        ? 50
                        : 150,
                height: isMobile ? 45 : 60,
                "@media (max-width: 600px)": {
                  width: isLigerDomain ? 40 : 110,
                  height: 35,
                },
              }}
              component="img"
              src={
                userDetails?.userName === "ricky" ||
                userDetails?.userName === "derek"
                  ? LigerLogo
                  : `${VISUALIZE__URL + logos?.logos?.websiteLogo} `
              }
              alt="headerlogo"
            />
          </Link>
        </Box>

        <Box
          sx={{
            display: isMobile ? "none" : "block",
            width: isMobile ? "75%" : "50%",
            margin: "0 auto",
            padding: "4px",
            borderRadius: "8px",
          }}
        >
          <SearchDropdown SearchList={setSearchList} />
        </Box>
        {/* {openSearch && isMobile ? (
          <Box
            sx={{
              display: "block",
              width: "50%",
              margin: "0 auto",
              padding: "5px",
              borderRadius: "8px",
            }}
          >
            <SearchDropdown SearchList={setSearchList} />
          </Box>
        ) : (
          <Box
            sx={{
              display: isMobile ? "none" : "block",
              width: isMobile ? "100%" : "50%",
              margin: "0 auto",
              padding: "5px",
              borderRadius: "8px",
            }}
          >
            <SearchDropdown SearchList={setSearchList} />
          </Box>
        )} */}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: isMobile ? 1 : 2,
          }}
        >
          {/* {isMobile && (
            <Box
              sx={{
                width: "50px",
                flexGrow: 1,
                position: "relative",
                display: "flex",
                alignItems: "center",
                pr: 1,
              }}
            >
              <SearchIcon
                onClick={() => setOpenSearch((prev) => !prev)} // toggle true/false
                sx={{
                  width: 24,
                  height: 24,
                  color: "#1976d2",
                  backgroundColor: "#f1f1f1",
                  borderRadius: "4px",
                  margin: "4px",
                  padding: "3px",
                  position: "absolute",
                  right: 0,
                  zIndex: 1,
                }}
              />
            </Box>
          )} */}
          <Typography
            variant="h6"
            sx={{
              mt: 1,
              display: { xs: "none", sm: "inline" },
              color: " #000000",
            }}
          >
            <span style={{ fontSize: "15px" }}>{t("welcome_back")}</span>
            <br />
            {t("hi")}, {userDetails && users_name}
          </Typography>

          {/* Profile Icon & Menu */}
          <IconButton
            size={isMobile ? "medium" : "large"}
            onClick={handleMenu}
            color="inherit"
            sx={{
              boxShadow: "1px 1px 3px 0px rgb(79 77 77 / 65%)",
              padding: "4px",
            }}
          >
            {userDetails?.userImage ? (
              <img
                src={CUSTOM_UPLOAD_BASE_URL + userDetails?.userImage}
                alt="Profile"
                style={{
                  width: isMobile ? 40 : 40,
                  height: isMobile ? 40 : 40,
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            ) : userDetails?.socialProfile ? (
              <img
                src={userDetails?.socialProfile}
                alt="Google Profile"
                onError={(e: any) => {
                  console.log("Image failed to load:", e.target.src);
                  console.log(
                    "Original socialProfile value:",
                    userDetails?.socialProfile
                  );
                  console.log(
                    "Are they the same?",
                    e.target.src === userDetails?.socialProfile
                  );
                  e.target.src = defaultProfile;
                }}
                style={{
                  width: isMobile ? 40 : 40,
                  height: isMobile ? 40 : 40,
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <img
                src={defaultProfile}
                alt="Profile"
                style={{
                  width: isMobile ? 40 : 40,
                  height: isMobile ? 40 : 40,
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            )}
          </IconButton>

          {/* Profile Menu */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            disableScrollLock={true} 
            PaperProps={{
              elevation: 3,
              sx: {
                width: isMobile ? 250 : 300,
                mt: 1.5,
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <Box sx={{ p: 2, textAlign: "center" }}>
              {userDetails?.userImage ? (
                <img
                  src={CUSTOM_UPLOAD_BASE_URL + userDetails?.userImage}
                  alt="Profile"
                  style={{
                    width: isMobile ? 40 : 40,
                    height: isMobile ? 40 : 40,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
              ) : userDetails?.socialProfile ? (
                <img
                  src={userDetails?.socialProfile}
                  alt="Google Profile"
                  onError={(e: any) => {
                    console.log("Image failed to load:", e.target.src);
                    console.log(
                      "Original socialProfile value:",
                      userDetails?.socialProfile
                    );
                    console.log(
                      "Are they the same?",
                      e.target.src === userDetails?.socialProfile
                    );
                    e.target.src = defaultProfile;
                  }}
                  style={{
                    width: isMobile ? 40 : 40,
                    height: isMobile ? 40 : 40,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <img
                  src={defaultProfile}
                  alt="Profile"
                  style={{
                    width: isMobile ? 40 : 40,
                    height: isMobile ? 40 : 40,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
              )}
              <Typography
                variant="h6"
                sx={{ mt: 1, fontSize: isMobile ? "1rem" : "1.25rem" }}
              >
                {users_name}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  mb: 1,
                  fontSize: isMobile ? "0.8rem" : "0.875rem",
                  wordBreak: "break-word",
                }}
              >
                {/* {userDetails?.userAccessTagName} */}
                {t(userDetails?.userAccessTagName || "", {
                  defaultValue: userDetails?.userAccessTagName,
                })}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                startIcon={<EditIcon />}
                sx={{ textTransform: "none" }}
                onClick={handleProfile}
              >
                {t("edit_profile")}
              </Button>
            </Box>
            <Divider />
            <MenuItem
              onClick={handleLogout}
              sx={{
                justifyContent: "space-between",
                color: "error.main",
                mt: 1,
                py: isMobile ? 1 : 1.5,
                fontWeight: "bold",
              }}
            >
              {t("logout")}
              <LogoutIcon sx={{ ml: 1, fontSize: isMobile ? 18 : 20 }} />
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
